// src/features/product/subscriptionActions.js
import { createAction } from '@reduxjs/toolkit';
import {
    getSubscriptionDuration,
    getAllSubscriptions,
    updateSubscription,
    removeSubscription
} from '../../services/subscriptionService';

// Action Creators
export const clearMessages = createAction('subscription/clearMessages');

// Subscription Actions
export const getSubscriptionDurationStart = createAction('subscription/getSubscriptionDurationStart');
export const getSubscriptionDurationSuccess = createAction('subscription/getSubscriptionDurationSuccess');
export const getSubscriptionDurationFailure = createAction('subscription/getSubscriptionDurationFailure');

export const getAllSubscriptionsStart = createAction('subscription/getAllSubscriptionsStart');
export const getAllSubscriptionsSuccess = createAction('subscription/getAllSubscriptionsSuccess');
export const getAllSubscriptionsFailure = createAction('subscription/getAllSubscriptionsFailure');

export const updateSubscriptionStart = createAction('subscription/updateSubscriptionStart');
export const updateSubscriptionSuccess = createAction('subscription/updateSubscriptionSuccess');
export const updateSubscriptionFailure = createAction('subscription/updateSubscriptionFailure');

export const removeSubscriptionStart = createAction('subscription/removeSubscriptionStart');
export const removeSubscriptionSuccess = createAction('subscription/removeSubscriptionSuccess');
export const removeSubscriptionFailure = createAction('subscription/removeSubscriptionFailure');



const mapSubscriptionOptions = (data) =>
    data.map(item => ({
    value: item.duration_days,
    label: item.duration_title,
    ...item
}));

// Fetch Subscription Durations
export const fetchSubscriptionDurations = () => async (dispatch) => {
    dispatch(getSubscriptionDurationStart());
    try {
        const response = await getSubscriptionDuration();
        const mappedData = mapSubscriptionOptions(response.data.data?.data);
        if(mappedData){
            dispatch(getSubscriptionDurationSuccess({
                data: mappedData,
                message: response.data.message,
            }));
        }
    } catch (error) {
        dispatch(getSubscriptionDurationFailure(error.message));
    }
};

// Fetch All Subscriptions
export const fetchAllSubscriptions = (data) => async (dispatch) => {
    dispatch(getAllSubscriptionsStart());
    try {
        const response = await getAllSubscriptions(data);
        dispatch(getAllSubscriptionsSuccess(response.data));
    } catch (error) {
        dispatch(getAllSubscriptionsFailure(error.message));
    }
};

// Update Subscription
export const submitUpdateSubscription = (id, data) => async (dispatch) => {
    dispatch(updateSubscriptionStart());
    try {
        const response = await updateSubscription(id, data);
        dispatch(updateSubscriptionSuccess(response.data));
    } catch (error) {
        dispatch(updateSubscriptionFailure(error.message));
    }
};

// Remove Subscription
export const deleteSubscription = (id) => async (dispatch) => {
    dispatch(removeSubscriptionStart());
    try {
        const response = await removeSubscription(id);
        dispatch(removeSubscriptionSuccess(response.data));
    } catch (error) {
        dispatch(removeSubscriptionFailure(error.message));
    }
};